import React from 'react';
import '../styles/loans.css';

const Loans = () => {
    return (
        <div className="loans-container" id='loans'>
            <h2 className="loans-head">How Our Loan System Works</h2>
            <div className="loans-content">
                <>
                    Our loan system is designed to offer you financial flexibility when you need it the most. Whether you're planning a big purchase, dealing with unexpected expenses, or looking to consolidate your debts, we provide a streamlined process to get you the funds you need quickly and easily.
                </>
                <>
                   <br /><br /> <strong>Step 1: Application</strong>
                    Start by filling out our simple online application form. You'll need to provide basic personal information, your financial status, and the amount you wish to borrow. This helps us understand your needs and find the best loan options for you.
                </>
                <>
                   <br /><br /> <strong>Step 2: Evaluation</strong>
                    Once we receive your application, our team will conduct a thorough review. We evaluate your creditworthiness and repayment capacity to tailor a loan package that suits your requirements. Our goal is to offer you competitive interest rates and flexible repayment terms.
                </>
                <>
                   <br /><br /> <strong>Step 3: Approval and Disbursement</strong>
                    Upon approval, you'll receive a detailed loan agreement. It outlines the loan amount, interest rate, repayment schedule, and any fees involved. After you agree to the terms, the funds will be promptly disbursed to your designated account, ready for you to use.
                </>
                <>
                   <br /><br /> <strong>Step 4: Repayment</strong>
                    We offer multiple repayment options to fit your financial situation. Our customer service team is always available to help you with any questions or adjustments needed during the repayment period. Transparency and flexibility are the cornerstones of our loan service.
                </>
                <>
                   <br /><br /> <strong>Get Started Today</strong>
                    Ready to take the next step? To begin the loan process, please send an email to <a href="mailto:support@skyhighntb.com">support@skyhighntb.com</a>. Include your full name, contact information, and a brief description of your loan needs. Our team will get back to you promptly to guide you through the next steps.
                </>
                <>
                    We look forward to helping you achieve your financial goals with ease and confidence. Contact us today and take the first step towards financial freedom.
                </>
            </div>
        </div>
    );
};

export default Loans;
